const STORAGE_KEY = 'onboarding_answers_v1';

export function getAnswers() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    console.error('Failed to read onboarding answers', e);
    return {};
  }
}

export function setAnswer(index, selectedIds) {
  try {
    const data = getAnswers();
    data[index] = Array.isArray(selectedIds) ? selectedIds : [];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (e) {
    console.error('Failed to save onboarding answer', e);
  }
}

export function setAnswers(payload) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload || {}));
  } catch (e) {
    console.error('Failed to save onboarding answers', e);
  }
}

export function clearAnswers() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    console.error('Failed to clear onboarding answers', e);
  }
}

export default {
  getAnswers,
  setAnswer,
  setAnswers,
  clearAnswers
};
